import {useEffect, useState} from "react";
import type { ContextProps } from '../../../types';
import {PageTitle} from "../../../Components/Landmarks";
import {braillerPackingListModel} from "./braillerPackingListFactory";
import {isObjectNullOrEmpty} from "../../../Utilities/Types/objectUtilities";
import {braillerPackingListApi} from "./braillerPackingListApi";
import {PackingListFooterView} from "../PackingListFooterView";
import {PackingListHeaderView} from "../PackingListHeaderView";
import type {BraillerPackingList} from "../packingList.types";

export const BraillerPackingListContainer = ({
                                                 handleApiCall,
                                                 braillerLoanId,
                                             }: ContextProps) => {
    const [braillerPackingList, setBraillerPackingList] = useState<BraillerPackingList | null>(null);

    const updatePackingList = (result: Record<string, unknown>) => {
        setBraillerPackingList(braillerPackingListModel(result));
    };

    const handleGetBraillerPackingList = () => {
        handleApiCall(() => braillerPackingListApi.getBraillerLoanItem(braillerLoanId), updatePackingList);
    };

    useEffect(() => {
        if (braillerLoanId)
            handleGetBraillerPackingList();
    }, []);

    if (!braillerPackingList) return null;

    return <>
        <PackingListHeaderView shipAddress={braillerPackingList.shipAddressFormatted}/>

        <div className={`packingList`}>

            <hr/>

            <PageTitle h1={`Packing List`}/>

            <p>Ship Date: {braillerPackingList.shipDate}</p>

            <p className={`text-center`}><b>The following item is contained in _______________ packages.</b></p>

            <div>Order Date: {braillerPackingList.dateCreatedFormatted}</div>
            {braillerPackingList.patron?.district &&
                <div>District: {braillerPackingList.patron.district.districtName}</div>
            }
            <div>Product Name: {braillerPackingList.braillerCatalogItem?.title}</div>
            <div>Model: {braillerPackingList.braillerCatalogItem?.model}</div>
            <div>Serial No: {braillerPackingList.inventoryBarCode}</div>
            <div>Packing Note: {braillerPackingList.braillerLoanStatusText}</div>
        </div>

        <PackingListFooterView/>

    </>;
};
